<template>
    <div class="signIn">
        <div class="signInCon" v-if="flag == 'zh_TW'">
            <div class="sign-title">1.連續簽到獎勵規則</div>
            <div class="sign-detail sign-detail-title">
                <div class="day">連續簽到</div>
                <div class="reward">獎勵</div>
            </div>
            <div class="sign-detail sign-detail-first" v-for="i in list">
                <div class="day">{{i.day}}</div>
                <div class="reward">{{i.value}}</div>
            </div>
            <div class="sign-detail sign-detail-surplus">
                <div class="surplus-con">
                    2.連續簽到天數，指用戶產生連續簽到行為的第1 天到第n天，如中圖間斷，則連簽天數從第一天開始算起。
                </div>
                <div class="surplus-con">
                    3.如用戶連簽至25天後，繼續保持連續簽到，則從第26天開始，每天的連簽行為都贈送30書券。
                </div>
                <div class="surplus-con">
                    4.簽到日歷中點擊漏簽日期可通過充值時贈送的補簽機會補簽該日，補簽日期不影響連簽獎勵的獲得。
                </div>
            </div>
        </div>
        <div class="signInCon" v-if="flag == 'zh_CN'">
            <div class="sign-title">1.连续签到奖励规则</div>
            <div class="sign-detail sign-detail-title">
                <div class="day">连续签到</div>
                <div class="reward">奖励</div>
            </div>
            <div class="sign-detail sign-detail-first" v-for="i in listcn">
                <div class="day">{{i.day}}</div>
                <div class="reward">{{i.value}}</div>
            </div>
            <div class="sign-detail sign-detail-surplus">
                <div class="surplus-con">
                    2.连续签到天数，指用户产生连续签到行为的第1 天到第n天，如中图间断，则连签天数从第一天开 始算起。
                </div>
                <div class="surplus-con">
                    3.如用户连签至25天后，继续保持连续签到，则从第26天开始，每天的连签行为都赠送30书券。
                </div>
                <div class="surplus-con">
                    4.签到日历中点击漏签日期可通过充值时赠送的补签机会补签该日，补签日期不影响连签奖励的获得。
                </div>
            </div>
        </div>
        <div class="signInCon" v-if="flag == 'en_US'">
            <div class="sign-title">1.Continuous check-in reward rules</div>
            <div class="sign-detail sign-detail-title">
                <div class="day">Continuous sign in</div>
                <div class="reward">Reward</div>
            </div>
            <div class="sign-detail sign-detail-first sign-detail-en" v-for="i in listen">
                <div class="day">{{i.day}}</div>
                <div class="reward">{{i.value}}</div>
            </div>
            <div class="sign-detail sign-detail-surplus">
                <div class="surplus-con">
                    2.The number of consecutive check-in days refers to the first day to the nth day when the user has a continuous check-in behavior. If there is a break in the middle, the number of days will be counted from the first day when the reader starts checking in again.
                </div>
                <div class="surplus-con">
                    3.If the user checks in continuously after seven days, from the 8th day onwards, 18 bonus + random rewards will be given for each consecutive check-in behavior.
                </div>
                <div class="surplus-con">
                    4.Click on the missed date in the check-in calendar to make up for that day through the check-in redemption card given after top-up. Note that the re-checkin date does not affect the acquisition of consecutive check-in rewards.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import '../../utils/lib/rem1'
    export default {
        name: "",
        data () {
            return {
                flag: 'zh_TW ',
                list: [
                    {day: '連續3天', value: '15書券+隨機獎勵'},
                    {day: '連續4天', value: '15書券+隨機獎勵'},
                    {day: '連續5天', value: '20書券+隨機獎勵'},
                    {day: '連續6天', value: '20書券+隨機獎勵'},
                    {day: '連續7天', value: '25書券+隨機獎勵'},
                    {day: '連續14天', value: '30書券+隨機獎勵'},
                    {day: '連續25天', value: '50書券+隨機獎勵'},
                    {day: '連續25天+', value: '30書券+隨機獎勵'},
                ],
                listcn: [
                    {day: '连续3天', value: '15書券+随机奖励'},
                    {day: '连续4天', value: '15書券+随机奖励'},
                    {day: '连续5天', value: '20書券+随机奖励'},
                    {day: '连续6天', value: '20書券+随机奖励'},
                    {day: '连续7天', value: '25書券+随机奖励'},
                    {day: '连续14天', value: '30書券+随机奖励'},
                    {day: '连续25天', value: '50書券+随机奖励'},
                    {day: '连续25天+', value: '30書券+随机奖励'},
                ],
                listen: [
                    {day: 'For 1 day', value: '10bonus+Random rewards'},
                    {day: 'For 2 days', value: '10bonus+Random rewards'},
                    {day: 'For 3 days', value: '10bonus+Random rewards'},
                    {day: 'For 4 days', value: '15bonus+Random rewards'},
                    {day: 'For 5 days', value: '15bonus+Random rewards'},
                    {day: 'For 6 days', value: '15bonus+Random rewards'},
                    {day: 'For 7 days', value: '15bonus+Random rewards'},
                    {day: 'For 7+ days', value: '18bonus+Random rewards'},
                ]
            }
        },
        mounted () {
            if (this.$route.query.lang) {
                this.flag = this.$route.query.lang
            } else {
                this.flag = 'zh_TW'
            }
        }
    }
</script>

<style lang="scss" scoped>
    .signIn{
        display: inline-block;
        width: 100%;
        min-height: 100vh;
        height: auto;
        background: #fff;
        letter-spacing: 0.01rem;
        font-weight: 400;
        .sign-title{
            font-size: 0.15rem;
            margin-left: 0.27rem;
            margin-top: 0.24rem;
        }
        .sign-detail{
            margin: 0.2rem 0.12rem 0;
            font-size: 0.15rem;
            display: inline-block;
            width: calc(100% - 0.24rem);
            .day:first-child{
                float: left;
                width: calc(50% - 0.21rem);
                margin-left: 0.21rem;
            }
            .reward:last-child{
                float: left;
                width: 50%;
            }
            &.sign-detail-en{
                font-size: 0.13rem;
                .day:first-child{
                    float: left;
                    width: calc(40% - 0.15rem);
                    margin-left: 0.15rem;
                }
                .reward:last-child{
                    float: left;
                    width: 55%;
                }
            }
        }
        .sign-detail-title{
            padding: 0.12rem 0;
            background: #EDF1F7;
            border-radius: 0.05rem;
            color: #666666;
            .reward:last-child{
                width: calc(50% - 0.06rem)!important;
                margin-left: 0.06rem;
            }
        }
        .sign-detail-first{
            margin: 0.15rem 0.12rem 0;
            color: #333;
        }
        .sign-detail-surplus{
            background: #FAFAFA;
            border-radius: 0.05rem;
            margin-bottom: 0.2rem;
            >.surplus-con:nth-child(1){
                margin-top: 0.15rem;
            }
            >.surplus-con{
                margin:0 0.145rem 0.21rem 0.1rem;
                line-height: 0.2rem;
                color: #000;
            }
        }
    }
</style>
